(() => {
  if (customElements.get('mancini-clinical-results-dialog')) return;

class ManciniClinicalResultsDialog extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dialog = this.querySelector('dialog');
    this.heading = this.querySelector('[data-clinical-results-heading]');
    this.viewport = this.querySelector('[data-clinical-results-viewport]');
    this.count = this.querySelector('[data-clinical-results-count]');
    this.cards = [...this.querySelectorAll('[data-clinical-result-groups]')];
    if (!this.dialog || !this.heading || this.cards.length === 0) return;

    this.dataset.ready = 'true';
    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.triggers = [...document.querySelectorAll('[data-clinical-results-dialog]')]
      .filter((trigger) => trigger.dataset.clinicalResultsDialog === this.dialog.id);

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger), { signal });
    });

    this.querySelectorAll('[data-clinical-results-close]').forEach((button) => {
      button.addEventListener('click', () => this.dialog.close(), { signal });
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    }, { signal });

    this.dialog.addEventListener('close', () => this.afterClose(), { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    document.body.classList.remove('mancini-clinical-results-open');
  }

  open(trigger) {
    const group = trigger.dataset.clinicalResultsGroup;
    if (!group) return;

    const visibleCards = this.cards.filter((card) => {
      const groups = card.dataset.clinicalResultGroups?.split(' ') ?? [];
      const isVisible = groups.includes(group);
      card.hidden = !isVisible;
      return isVisible;
    });

    if (visibleCards.length === 0) return;

    this.lastTrigger = trigger;
    this.heading.textContent = trigger.dataset.clinicalResultsTitle || this.heading.textContent;
    const caseLabel = visibleCards.length === 1 ? this.dataset.caseSingular : this.dataset.casePlural;
    this.count.textContent = `${visibleCards.length} ${caseLabel}`;
    this.dialog.dataset.visibleCount = String(visibleCards.length);
    this.viewport?.scrollTo({ top: 0, behavior: 'auto' });
    document.body.classList.add('mancini-clinical-results-open');

    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
  }

  afterClose() {
    document.body.classList.remove('mancini-clinical-results-open');
    this.lastTrigger?.focus();
  }
}

customElements.define('mancini-clinical-results-dialog', ManciniClinicalResultsDialog);
})();
